export default "__VITE_ASSET__f0b4b0cf__"